export const DownloadTokenAuth = {
    HeaderName: "Download",
};
